import { render, staticRenderFns } from "./MessageAddUsersLicence.vue?vue&type=template&id=c4a12856"
import script from "./MessageAddUsersLicence.vue?vue&type=script&lang=js"
export * from "./MessageAddUsersLicence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports